module.exports = __webpack_public_path__ + "img/065-woman.2f98b54e.png";